import { plugin, debug } from 'light-component';
import { convert, TreeService, useTranslation } from '@common';
import * as Base from '@base';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { AreaTreeSelectProps } from './types';

const { SHOW_ALL } = Base.TreeSelect;

export function WidgetAreaTreeSelect(props: AreaTreeSelectProps): ReactElement {
  debug.widget('dashboard AreaTreeSelect', props);

  const [t] = useTranslation();

  const treeData = props.options?.map(item => ({
    ...item,
    icon: convert('AreaSvgIcon'),
    groupType: 'area' as const
  }));

  const onChange = (value: string[]): void => {
    if (value == null || value.length === 0) {
      props.onChange?.(undefined);
      return;
    }
    props.onChange?.(value);
  };

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Base.TreeSelect
        className={styles.treeSelect}
        treeIcon
        value={props.value}
        placeholder={t(props.placeholder ?? t('请选择分区'))}
        showSearch
        allowClear
        autoClearSearchValue
        size='middle'
        treeCheckable
        treeNodeFilterProp='title'
        treeDefaultExpandedKeys={[props.options?.find(item => item.parent === '')?._id ?? '']}
        treeLine={{ showLeafIcon: false }}
        popupMatchSelectWidth={false}
        treeData={new TreeService().toTree(treeData ?? [])}
        onChange={onChange}
        maxTagCount={3}
        showCheckedStrategy={SHOW_ALL}
      />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'areaTree', component: WidgetAreaTreeSelect });
